export const DEFAULT_CONTENT = {
  announcement: "",
  hero_eyebrow: "Food safety diary · Built for UK hospitality",
  hero_title_1: "Ditch the clipboard.",
  hero_title_2: "Pass every inspection.",
  hero_subtitle: "KitchenAudit replaces your SFBB pack, temperature sheets, cleaning rotas and HACCP folder with one digital diary — fast on a phone for your team, clear on a dashboard for you.",
  hero_cta: "Start {days}-day free trial",
  hero_image: "",
  staff_image: "",
  hero_points: ["£69 per venue / month", "Every feature included", "Staff don't take a seat"],
  features_eyebrow: "Everything an EHO asks for",
  features_title: "Exception-led, not paperwork-led.",
  features_text: "Problems rise to the top: overdue checks, out-of-range readings, unresolved incidents and expiring certificates — so you fix them before the inspector finds them.",
  features: [
    { title: "Daily diary & checks", text: "Opening, service, cleaning and closing checks scheduled for every venue, with sign-off and overdue flags." },
    { title: "Temperature logs", text: "Fridges, freezers, cooking, cooling, reheating and hot holding — with UK limits and instant out-of-range alerts." },
    { title: "Incidents & corrective actions", text: "Every failure becomes a tracked incident: food disposition, maintenance link, manager review, safe-to-resume sign-off." },
    { title: "AI HACCP plans", text: "Draft a full 7-principle HACCP plan from your menu in minutes. Version it, review it, and get staff to acknowledge it." },
    { title: "14-allergen matrix", text: "A live allergen matrix for every dish, ready for Natasha's Law questions at the pass." },
    { title: "EHO-ready audit pack", text: "One click for checks, temperatures, incidents, training, deliveries and allergens for any date range." },
  ],
  staff_eyebrow: "Your own staff app",
  staff_title: "Every business gets its own installable app.",
  staff_text: "The moment you create an account, your team gets a private link with your name on it. Add it to the home screen, tap a 6-digit PIN, and they're logging temperatures in seconds — no passwords, no app store.",
  pricing_title: "One price per venue. Everything included.",
  pricing_text: "No tiers, no setup fee, no contract. Your whole team uses the staff app for free.",
  price_amount: "£69",
  price_unit: "/ venue / month",
  price_note: "{days}-day free trial. Cancel anytime.",
  price_features: ["SFBB daily diary", "Temperature & cleaning logs", "AI HACCP generator", "AI food safety assistant", "Allergen matrix (14)", "Incidents & maintenance links", "Training & expiry reminders", "EHO audit pack"],
  footer_text: "Built around FSA Safer Food Better Business guidance.",
};

export const imageUrl = (path, fallback) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : fallback);

export function withTrialDays(c, days) {
  return Object.fromEntries(Object.entries(c).map(([k, v]) => [k, typeof v === "string" ? v.replaceAll("{days}", days) : v]));
}

export function mergeContent(saved) {
  const out = { ...DEFAULT_CONTENT };
  Object.entries(saved || {}).forEach(([k, v]) => {
    if (k in DEFAULT_CONTENT && (Array.isArray(v) ? v.length : v !== "" && v != null)) out[k] = v;
  });
  if (saved?.announcement !== undefined) out.announcement = saved.announcement;
  out.features = DEFAULT_CONTENT.features.map((d, i) => {
    const s = saved?.features?.[i] || {};
    return { title: s.title || d.title, text: s.text || d.text };
  });
  return out;
}
